// extracted by mini-css-extract-plugin
export default {"introContainer":"intro-page_introContainer__ZmNQ-","introText":"intro-page_introText__NJSOH"};